export default __webpack_public_path__ + "static/media/img-c-00-btn-egt.3570ff0a.png";